module.exports = __webpack_public_path__ + "static/img/_szafa_42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/_szafa_42.svg
// module id = 4yo7
// module chunks = 0